module.exports = __webpack_public_path__ + "img/android_btn.aba7c871.png";